import { render, staticRenderFns } from "./MobileWarningModal.vue?vue&type=template&id=939f45f4&"
import script from "./MobileWarningModal.vue?vue&type=script&lang=js&"
export * from "./MobileWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./MobileWarningModal.vue?vue&type=style&index=0&id=939f45f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports